import { TeaInitParams } from './type/btm-core';
import { TeaSdkV4, TeaSdkV5 } from './type/btm-tea-core';
import Core from './index';

export interface TeaReportParams {
  eventName: string;
  eventParams: Record<string, any>;
}
const DEFAULT_TEA_CDN_NAME = 'collectEvent';

const TEA_VERSION = '5.x';

export function isVersionOverFive(version?: string): boolean {
  return Number(version) >= 5;
}

export class BtmTeaCore {
  tea?: typeof TeaSdkV4.Core & typeof TeaSdkV5.Core;

  cdnReportName?: string;

  teaVersion?: string;

  devlog?: boolean;

  // 自定义上报函数
  customReport?: (event: string, params: Record<string, any>, useBeacon?: boolean) => void;

  constructor(
    initParams?: TeaInitParams,
    report?: (event: string, params: Record<string, any>) => void,
    devlog?: boolean
  ) {
    if (report) {
      this.customReport = report;
    } else if (initParams) {
      const { tea, cdnReportName, teaVersion } = initParams;
      this.tea = tea;
      this.cdnReportName = cdnReportName || DEFAULT_TEA_CDN_NAME;
      this.teaVersion = teaVersion || TEA_VERSION;
    }
    this.devlog = devlog;
  }

  report(params: TeaReportParams, useBeacon?: boolean): void {
    const { eventName, eventParams } = params;
    if (window?.__UNIVERSAL_TRACKER_DEBUG__?.getVerifyEvents) {
      window?.__UNIVERSAL_TRACKER_DEBUG__?.getVerifyEvents({
        eventName,
        eventParams
      });
    }
    try {
      Core?.reportCallback?.(); // 上报回调函数，业务方上报前Tea.config配置会变化的全局参数
      // 如果有自定义上报方法，则用自定义上报
      if (this.customReport) {
        this.customReport(eventName, eventParams, useBeacon);
      } else if (this.tea) {
        const isHasEvent = isVersionOverFive(this.teaVersion?.[0]) || this.tea?.event;
        if (this.devlog) {
          console.log('[BTM logger] tea', eventName, eventParams.btm, eventParams.position, eventParams);
        }
        if (isHasEvent) {
          useBeacon ? this.tea?.beconEvent(eventName, eventParams) : this.tea?.event(eventName, eventParams);
        } else {
          useBeacon ? this.tea('beconEvent', eventName, eventParams) : this.tea(eventName, eventParams);
        }
        return;
      } else if (this.cdnReportName) {
        // cdn引入
        if (useBeacon) {
          (window as any)[`${this.cdnReportName}`]('beconEvent', eventName, eventParams);
        } else {
          (window as any)[`${this.cdnReportName}`](eventName, eventParams);
        }
      } else {
        console.error('btm sdk report error -> 无tea实例且无cdn name，上报失败');
      }
    } catch (error) {
      console.error('btm sdk report error -> ', error);
    }
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXX0=